/**
 * NOLAS 2026, application multi evenement e.labriquerie.net.
 * src/i18n/fr.cvmIa.ts
 *
 * Messages de l'IA qui sert dans le module CV Matching (cahier des charges,
 * vague 5) côté espace exposant : le bouton « Rédiger avec l'assistance »
 * (composant isolé AssistProfilButton) et les raisons lisibles quand
 * l'assistance n'est pas disponible. Préfixe `cvmIa.`, fusionné dans fr.ts
 * comme fr.offres.ts. Les messages de l'écran d'administration restent
 * sous `aiGov.` (fr.aiGov.ts).
 *
 * Mikael - chef de projet - 2026-09-20
 */
export const messagesCvmIaFr: Record<string, string> = {
  'cvmIa.assist.bouton': 'Rédiger avec l’assistance',
  'cvmIa.assist.enCours': 'Rédaction en cours…',
  'cvmIa.assist.champ': 'Décrivez en quelques mots le profil que vous cherchez',
  'cvmIa.assist.placeholder':
    'Ex. : technicien de maintenance en CDI, confirmé, automatisme et électricité',
  'cvmIa.assist.aide':
    'L’assistance propose un intitulé, un contrat, un niveau, un secteur et des compétences. Vous relisez et modifiez tout avant d’enregistrer. Ne mettez ni nom, ni courriel, ni téléphone.',
  'cvmIa.assist.proposer': 'Proposer',
  'cvmIa.assist.annuler': 'Annuler',
  'cvmIa.assist.propose': 'Proposition appliquée : relisez chaque champ.',
  'cvmIa.assist.indisponible': 'Assistance non disponible : {raison}',
  'cvmIa.assist.vide': 'Écrivez d’abord quelques mots.',
  'cvmIa.assist.erreur': 'Impossible de joindre l’assistance. Vous pouvez remplir le profil à la main.',

  'cvmIa.raison.desactivee': 'la fonction n’est pas activée par l’organisation.',
  'cvmIa.raison.registre': 'la fonction n’existe pas sur cet événement.',
  'cvmIa.raison.fournisseur': 'aucun fournisseur d’IA n’est actif.',
  'cvmIa.raison.cle': 'aucune clé d’IA n’est déposée.',
  'cvmIa.raison.budget': 'le budget du mois est atteint.',
  'cvmIa.raison.consentement': 'le consentement requis manque.',
  'cvmIa.raison.entree_coordonnees':
    'votre texte contient un courriel ou un téléphone, retirez-le.',
  'cvmIa.raison.question_vide': 'écrivez d’abord quelques mots.',
  'cvmIa.raison.reponse_invalide': 'la réponse reçue n’était pas exploitable.',
  'cvmIa.raison.hors_bornes': 'la réponse reçue n’était pas exploitable.',
  'cvmIa.raison.secteur_inconnu': 'le secteur proposé n’existe pas ici.',
  'cvmIa.raison.coordonnees': 'la réponse contenait une coordonnée, elle a été refusée.',
  'cvmIa.raison.autre': 'réessayez dans un instant ou remplissez le profil à la main.',
};
